import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest,
  DefaultApiApproveWorkflowStepPaymentRequestsRequest,
  DefaultApiCreateBankTransfersRequest,
  DefaultApiDownloadBankTransferFileRequest,
  DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest,
  DefaultApiDownloadPaymentRequestsCsvRequest,
  DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest,
  DefaultApiGetPaymentRequestDetailRequest,
  DefaultApiGetPaymentRequestEvidenceFileRequest,
  DefaultApiPutPaymentRequestRequest,
  DefaultApiSearchBankTransfersRequest,
  DefaultApiSearchPaymentRequestsRequest,
  DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest,
  DefaultApiUploadPaymentRequestEvidenceImageRequest,
  DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest,
  DefaultApiGetPaymentRequestsBankAccountsListRequest,
  DefaultApiPostPaymentRequestsBankAccountRequest,
  DefaultApiPutPaymentRequestsBankAccountRequest,
  DefaultApiGetDraftPaymentRequestRequest,
  DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest,
  DefaultApiUpdatePaymentRequestEvidenceRequest,
  DefaultApiGetDraftPaymentRequestEvidenceFileRequest,
  DefaultApiQueryByIdsPaymentRequestsRequest,
  DefaultApiGetBankTransferRequest,
  DefaultApiCancelPaymentRequestRequest,
  DefaultApiDownloadBankTransfersCsvRequest,
  DefaultApiDeletePaymentRequestEvidenceRequest,
  DefaultApiSearchMyPaymentRequestsRequest,
  DefaultApiCreateDraftOfPaymentRequestsRequest,
  DefaultApiCompleteRedirectFromSlackRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const approveWorkflowStepPaymentRequests = async (
  instance: AxiosInstance,
  params: DefaultApiApproveWorkflowStepPaymentRequestsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).approveWorkflowStepPaymentRequests(params)
}

export const createBankTransfers = async (
  instance: AxiosInstance,
  params: DefaultApiCreateBankTransfersRequest
) => {
  return await userApiDefaultApiFactory(instance).createBankTransfers(params)
}

export const downloadBankTransferFile = async (
  instance: AxiosInstance,
  params: DefaultApiDownloadBankTransferFileRequest
) => {
  return await userApiDefaultApiFactory(instance).downloadBankTransferFile(
    params,
    {
      responseType: 'arraybuffer',
    }
  )
}

export const getPaymentRequestDetail = async (
  instance: AxiosInstance,
  params: DefaultApiGetPaymentRequestDetailRequest
) => {
  return await userApiDefaultApiFactory(instance).getPaymentRequestDetail(
    params
  )
}

export const getPaymentRequestEvidenceFile = async (
  instance: AxiosInstance,
  params: DefaultApiGetPaymentRequestEvidenceFileRequest
) => {
  return await userApiDefaultApiFactory(instance).getPaymentRequestEvidenceFile(
    params
  )
}

export const searchBankTransfers = async (
  instance: AxiosInstance,
  params: DefaultApiSearchBankTransfersRequest
) => {
  return await userApiDefaultApiFactory(instance).searchBankTransfers(params)
}

export const searchPaymentRequests = async (
  instance: AxiosInstance,
  params: DefaultApiSearchPaymentRequestsRequest
) => {
  return await userApiDefaultApiFactory(instance).searchPaymentRequests(params)
}

export const getAnalysisInvoiceOfPaymentRequest = async (
  instance: AxiosInstance,
  params: DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getAnalysisInvoiceOfPaymentRequest(params)
}

export const analyzeInvoiceOfPaymentRequests = async (
  instance: AxiosInstance,
  params: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).analyzeInvoiceOfPaymentRequests(params)
}

export const submitCompletedWorkflowOfPaymentRequests = async (
  instance: AxiosInstance,
  params: DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).submitCompletedWorkflowOfPaymentRequests(params)
}

export const downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest =
  async (
    instance: AxiosInstance,
    params: DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest
  ) => {
    return await userApiDefaultApiFactory(
      instance
    ).downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(params, {
      responseType: 'arraybuffer',
    })
  }

export const downloadPaymentRequestsCsv = async (
  instance: AxiosInstance,
  params: DefaultApiDownloadPaymentRequestsCsvRequest
) => {
  return await userApiDefaultApiFactory(instance).downloadPaymentRequestsCsv(
    params,
    {
      responseType: 'arraybuffer',
    }
  )
}

export const uploadPaymentRequestEvidenceImage = async (
  instance: AxiosInstance,
  params: DefaultApiUploadPaymentRequestEvidenceImageRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).uploadPaymentRequestEvidenceImage(params)
}

export const getDraftPaymentRequestsOnlyCreatedOwn = async (
  instance: AxiosInstance,
  params: DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getDraftPaymentRequestsOnlyCreatedOwn(params)
}
export const putPaymentRequest = async (
  instance: AxiosInstance,
  params: DefaultApiPutPaymentRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).putPaymentRequest(params)
}

export const getPaymentRequestsBankAccountsList = async (
  instance: AxiosInstance,
  params: DefaultApiGetPaymentRequestsBankAccountsListRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getPaymentRequestsBankAccountsList(params)
}

export const postPaymentRequestsBankAccount = async (
  instance: AxiosInstance,
  params: DefaultApiPostPaymentRequestsBankAccountRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).postPaymentRequestsBankAccount(params)
}

export const putPaymentRequestsBankAccount = async (
  instance: AxiosInstance,
  params: DefaultApiPutPaymentRequestsBankAccountRequest
) => {
  return await userApiDefaultApiFactory(instance).putPaymentRequestsBankAccount(
    params
  )
}

export const getDraftPaymentRequest = async (
  instance: AxiosInstance,
  params: DefaultApiGetDraftPaymentRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).getDraftPaymentRequest(params)
}

export const submitCompletedWorkflowOfDraftPaymentRequests = async (
  instance: AxiosInstance,
  params: DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).submitCompletedWorkflowOfDraftPaymentRequests(params)
}

export const updatePaymentRequestEvidence = async (
  instance: AxiosInstance,
  params: DefaultApiUpdatePaymentRequestEvidenceRequest
) => {
  return await userApiDefaultApiFactory(instance).updatePaymentRequestEvidence(
    params
  )
}

export const getDraftPaymentRequestEvidenceFile = async (
  instance: AxiosInstance,
  params: DefaultApiGetDraftPaymentRequestEvidenceFileRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getDraftPaymentRequestEvidenceFile(params)
}

export const queryByIdsPaymentRequests = async (
  instance: AxiosInstance,
  params: DefaultApiQueryByIdsPaymentRequestsRequest
) => {
  return await userApiDefaultApiFactory(instance).queryByIdsPaymentRequests(
    params
  )
}

export const downloadPaymentRequestsCsvForPaymentRequestIdsSpecification =
  async (
    instance: AxiosInstance,
    params: DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest
  ) => {
    return await userApiDefaultApiFactory(
      instance
    ).downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(params, {
      responseType: 'arraybuffer',
    })
  }

export const getBankTransfer = async (
  instance: AxiosInstance,
  params: DefaultApiGetBankTransferRequest
) => {
  return await userApiDefaultApiFactory(instance).getBankTransfer(params)
}

export const cancelPaymentRequest = async (
  instance: AxiosInstance,
  params: DefaultApiCancelPaymentRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).cancelPaymentRequest(params)
}

export const downloadBankTransfersCsv = async (
  instance: AxiosInstance,
  params: DefaultApiDownloadBankTransfersCsvRequest
) => {
  return await userApiDefaultApiFactory(instance).downloadBankTransfersCsv(
    params,
    {
      responseType: 'arraybuffer',
    }
  )
}

export const deletePaymentRequestEvidence = async (
  instance: AxiosInstance,
  params: DefaultApiDeletePaymentRequestEvidenceRequest
) => {
  return await userApiDefaultApiFactory(instance).deletePaymentRequestEvidence(
    params
  )
}

export const searchMyPaymentRequests = async (
  instance: AxiosInstance,
  params: DefaultApiSearchMyPaymentRequestsRequest
) => {
  return await userApiDefaultApiFactory(instance).searchMyPaymentRequests(
    params
  )
}

export const createDraftOfPaymentRequests = async (
  instance: AxiosInstance,
  params: DefaultApiCreateDraftOfPaymentRequestsRequest
) => {
  return await userApiDefaultApiFactory(instance).createDraftOfPaymentRequests(
    params
  )
}

export const completeRedirectFromSlack = async (
  instance: AxiosInstance,
  params: DefaultApiCompleteRedirectFromSlackRequest
) => {
  return await userApiDefaultApiFactory(instance).completeRedirectFromSlack(
    params
  )
}

// Do Not Remove this line ===@import api client===
